/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_SubmitInputs */

const en_signin_submit = /** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const ar_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const he_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const ur_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const es_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const fr_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const de_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const pt_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const hi_signin_submit = en_signin_submit;

/** @type {(inputs: Signin_SubmitInputs) => LocalizedString} */
const bn_signin_submit = en_signin_submit;

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Signin_SubmitInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_submit = /** @type {((inputs?: Signin_SubmitInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_SubmitInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_submit(inputs)
	if (locale === "he") return he_signin_submit(inputs)
	if (locale === "ur") return ur_signin_submit(inputs)
	if (locale === "es") return es_signin_submit(inputs)
	if (locale === "fr") return fr_signin_submit(inputs)
	if (locale === "de") return de_signin_submit(inputs)
	if (locale === "pt") return pt_signin_submit(inputs)
	if (locale === "hi") return hi_signin_submit(inputs)
	if (locale === "bn") return bn_signin_submit(inputs)
	return /** @type {LocalizedString} */ ("Sign in")
});